import { UserModuleManagementState } from '@pages/profile-module-management/store/state/user-module-management.state';
import { ProfileModulesOrderState } from '@pages/profile-module-management/store/state/profile-modules-order.state';

export const userModuleManagementState = [UserModuleManagementState, ProfileModulesOrderState];
